import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import OpenDetails from "./OpenDetails";
import {
  GET_ALL_MERCHANT_DATA,
} from "../../../utils/constant";
import useApiServices from "../../../utils/useApiServices";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

function Details({ toggleRightBar, type1 }) {
  const [merchantData, setMerchantData] = useState([]);
  const [openView, setOpenView] = useState(false);
  const [mid, setMid] = useState("");
  const { apiCallFnforGet } = useApiServices();

  useEffect(() => {
    fetchMerchantData();
  }, []);

  const fetchMerchantData = async () => {
    try {
      const response = await apiCallFnforGet(GET_ALL_MERCHANT_DATA);
      if (response.statusCode === 200) {
        const finalResp = response.data.map((item, i) => ({
          id: i,
          companyName: item.companyName,
          fullName: item.fullName,
          mid: item.mid,
          userName: item.userName,
          action: (
            <>
              <button
                className="badge badge-rounded badge-warning "
                onClick={() => openDetails(item?.mid)}
              >
                View
              </button>
            </>
          ),
        }));
        setMerchantData(finalResp);
      } else {
        setMerchantData([]);
      }
    } catch (error) {
      console.error("Error fetching merchant data:", error);
    }
  };
  const openDetails = (mid) => {
    setMid(mid);
    setOpenView(true);
  };
  const handleClose = () => {
    setMid("");
    setOpenView(false);
  };

  const columns = [
    { headerName: "Company Name", field: "companyName", minWidth: 310 },
    { headerName: "Authorised Person Name", field: "fullName", minWidth: 250 },
    { headerName: "Merchant Id", field: "mid", minWidth: 190 },
    { headerName: "User Name", field: "userName", minWidth: 250 },
    { headerName: "Action", field: "action", minWidth: 150 },
  ];

  return (
    <>
      <div className="container-fluid">
        <div className="d-flex justify-content-start align-items-center">
          <button
            type="button"
            class="btn-close m-3"
            onClick={toggleRightBar}
          ></button>

          <div className="fs-2 text-dark fw-bold">Merchant Details</div>
        </div>

        <Card.Body>
          <div style={{ height: "500px", width: "100%" }}>
            {!openView ? (
              <DataGrid
                rows={merchantData}
                columns={columns?.map((column) => ({
                  ...column,
                  renderCell: (params) =>
                    column.field === "action" ? params.value : params.value,
                }))}
                slots={{
                  toolbar: GridToolbar,
                }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                  },
                }}
              />
            ) : openView ? (
              <OpenDetails mid={mid} handleClose={handleClose} />
            ) : null}
          </div>

          <div className="report-grid-view">
            <div className="material-table-records mb-3">
            </div>
          </div>
        </Card.Body>
      </div>
    </>
  );
}

export default Details;
